var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeopleKusama(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10841_15311)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 19.165C15.0617 19.165 19.165 15.0617 19.165 9.99996C19.165 4.93827 15.0617 0.834961 9.99996 0.834961C4.93827 0.834961 0.834961 4.93827 0.834961 9.99996C0.834961 15.0617 4.93827 19.165 9.99996 19.165Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4376 6.97628C12.0103 6.76895 11.4983 6.66528 10.9014 6.66528H6.91504V13.7333H8.93179V11.5752H10.9014C11.4983 11.5752 12.0103 11.4747 12.4376 11.2737C12.8711 11.0663 13.204 10.7805 13.4365 10.4161C13.669 10.0454 13.7852 9.61188 13.7852 9.11555C13.7852 8.62549 13.669 8.19827 13.4365 7.83387C13.204 7.46319 12.8711 7.17733 12.4376 6.97628ZM8.93179 9.96371H10.7883C11.0899 9.96371 11.3255 9.88832 11.4951 9.73753C11.6648 9.58675 11.7496 9.37942 11.7496 9.11555C11.7496 8.85167 11.6648 8.64748 11.4951 8.50298C11.3255 8.35219 11.0899 8.2768 10.7883 8.2768H8.93179V9.96371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 3.7007C11.4173 4.48357 10.7826 5.1182 9.99978 5.1182C9.21692 5.1182 8.58228 4.48357 8.58228 3.7007C8.58228 2.91784 9.21692 2.2832 9.99978 2.2832C10.7826 2.2832 11.4173 2.91784 11.4173 3.7007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4173 16.3007C11.4173 17.0836 10.7826 17.7182 9.99978 17.7182C9.21692 17.7182 8.58228 17.0836 8.58228 16.3007C8.58228 15.5178 9.21692 14.8832 9.99978 14.8832C10.7826 14.8832 11.4173 15.5178 11.4173 16.3007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1644 8.0787C15.4864 8.47014 14.6195 8.23784 14.228 7.55986C13.8366 6.88188 14.0689 6.01495 14.7469 5.62352C15.4249 5.23209 16.2918 5.46438 16.6832 6.14236C17.0747 6.82034 16.8424 7.68727 16.1644 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.25247 14.3787C4.57449 14.7701 3.70756 14.5378 3.31613 13.8599C2.92469 13.1819 3.15699 12.315 3.83497 11.9235C4.51295 11.5321 5.37988 11.7644 5.77131 12.4424C6.16274 13.1203 5.93045 13.9873 5.25247 14.3787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.83496 8.0787C4.51294 8.47013 5.37987 8.23784 5.7713 7.55986C6.16274 6.88188 5.93044 6.01495 5.25246 5.62352C4.57448 5.23208 3.70755 5.46438 3.31612 6.14236C2.92469 6.82034 3.15698 7.68727 3.83496 8.0787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7469 14.3787C15.4249 14.7701 16.2918 14.5378 16.6832 13.8599C17.0747 13.1819 16.8424 12.3149 16.1644 11.9235C15.4864 11.5321 14.6195 11.7644 14.228 12.4424C13.8366 13.1203 14.0689 13.9873 14.7469 14.3787Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10841_15311"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleKusama);
export default __webpack_public_path__ + "static/media/people-kusama.606a208007229ff18436ca6e8c916f57.svg";
export { ForwardRef as ReactComponent };